import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Camera } from 'lucide-react';
import { useTheme } from '../../styles/ThemeContext';
interface PhotoToastProps {
  isVisible: boolean;
  message: string;
  subtitle: string;
  onDismiss: () => void;
}
export function PhotoToast({
  isVisible,
  message,
  subtitle,
  onDismiss
}: PhotoToastProps) {
  const {
    isDark
  } = useTheme();
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onDismiss();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onDismiss]);
  return <AnimatePresence data-id="element-316">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: -20,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: -20,
      scale: 0.95
    }} transition={{
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed top-8 left-1/2 -translate-x-1/2 z-[100]" data-id="element-317">
          <div className={`flex items-center gap-3 px-5 py-3 rounded-xl backdrop-blur-xl border shadow-2xl ${isDark ? 'bg-slate-900/90 border-white/10' : 'bg-white/90 border-white/40'}`} data-id="element-318">
            <div className={`p-2 rounded-lg ${isDark ? 'bg-cyan-500/20' : 'bg-teal-500/15'}`} data-id="element-319">
              <Camera className={`w-4 h-4 ${isDark ? 'text-cyan-400' : 'text-teal-600'}`} data-id="element-320" />
            </div>
            <div data-id="element-321">
              <p className={`text-sm font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-322">
                {message}
              </p>
              <p className={`text-xs ${isDark ? 'text-white/50' : 'text-gray-500'}`} data-id="element-323">
                {subtitle}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}